
import { HttpResponse } from "../auth/AuthInterface";

export const defaultFolio: FolioProps = { idFolio: 0, numeroFolio: '', numeroExpediente: '', numeroExhortoRecibido: '', cuantia: '', tipoJuicio: '', tipoCalificacion: '', partes: [], generarExpediente: false, observaciones: '', esExhorto: false, }

export interface BuscarFolioParams { 
    numeroFolio:        string;   
    idAutoridad:        number;
}

export interface FolioProps {
    idFolio:                number;
    numeroFolio:            string;
    numeroExpediente:       string;
    numeroExhortoRecibido:  string;
    tipoJuicio:             string;
    tipoCalificacion:       string;
    partes:                 Parte[];
    generarExpediente:      boolean;
    observaciones:          string;
    cuantia:                string;
    esExhorto:              boolean;   
}

export interface Parte {
    id:             number;
    idTipoParte:    number;
    tipoParte:      string;
    idPersona:      number;
    persona:        string;
    idTipoPersona:  number;
}

export interface BuscarFolioResponse extends HttpResponse, FolioProps {}

export interface GenerarExhortoRecibidoParams { 
    idFolio:            number;   
    idAutoridad:        number;
}

export interface GenerarExhortoRecibidoResponse extends HttpResponse, FolioProps {}

export interface GenerarExpedienteParams { 
    idFolio:            number;   
    idAutoridad:        number;
}

export interface GenerarExpedienteResponse extends HttpResponse, FolioProps {}